import { render, staticRenderFns } from "./ConsultantInvoiceDetailPage.vue?vue&type=template&id=1f3fc084&scoped=true&"
import script from "./ConsultantInvoiceDetailPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConsultantInvoiceDetailPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ConsultantInvoiceDetailPage.vue?vue&type=style&index=0&id=1f3fc084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fc084",
  null
  
)

export default component.exports